module.exports = "/images/vendor/desiigner-svg/svg/ui/trophy.svg?06fcfc96bbf7336897a4f598cad6fc2f";